import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';

import {
  ThfBreadcrumb,
  ThfDialogService,
  ThfDynamicFormComponent,
  ThfGridComponent,
  ThfGridRowActions,
  ThfNotificationService,
  ThfPageAction } from '@totvs/thf-ui';

import * as util from './../../utils/util';

import { ThfPageDynamicEditActions } from './thf-page-dynamic-edit-actions.interface';
import { ThfPageDynamicEditField } from './thf-page-dynamic-edit-field.interface';
import { ThfPageDynamicService } from './thf-page-dynamic.service';

export const thfPageDynamicEditLiteralsDefault = {
  en: {
    cancelConfirmMessage: 'Are you sure you want to cancel this operation?',
    detailActionNew: 'New',
    pageActionCancel: 'Cancel',
    pageActionSave: 'Save',
    pageActionSaveNew: 'Save and new',
    registerNotFound: 'Register not found.',
    saveNewNotificationSuccessSave: 'Resource successfully saved.',
    saveNewNotificationSuccessUpdate: 'Resource successfully updated.',
    saveNewNotificationWarning: 'Form must be filled out correctly.',
    saveNotificationSuccessSave: 'Resource successfully saved.',
    saveNotificationSuccessUpdate: 'Resource successfully updated.',
    saveNotificationWarning: 'Form must be filled out correctly.',
  },
  es: {
    cancelConfirmMessage: 'EstÃ¡ seguro de que desea cancelar esta operaciÃ³n?',
    detailActionNew: 'Nuevo',
    pageActionCancel: 'Cancelar',
    pageActionSave: 'Guardar',
    pageActionSaveNew: 'Guardar y nuevo',
    registerNotFound: 'Registro no encontrado.',
    saveNewNotificationSuccessSave: 'Recurso salvo con Ã©xito.',
    saveNewNotificationSuccessUpdate: 'Recurso actualizado con Ã©xito.',
    saveNewNotificationWarning: 'El formulario debe llenarse correctamente.',
    saveNotificationSuccessSave: 'Recurso salvo con Ã©xito.',
    saveNotificationSuccessUpdate: 'Recurso actualizado con Ã©xito.',
    saveNotificationWarning: 'El formulario debe llenarse correctamente.',
  },
  pt: {
    cancelConfirmMessage: 'Tem certeza que deseja cancelar esta operaÃ§Ã£o?',
    detailActionNew: 'Novo',
    pageActionCancel: 'Cancelar',
    pageActionSave: 'Salvar',
    pageActionSaveNew: 'Salvar e novo',
    registerNotFound: 'Registro nÃ£o encontrado.',
    saveNewNotificationSuccessSave: 'Recurso salvo com sucesso.',
    saveNewNotificationSuccessUpdate: 'Recurso atualizado com sucesso.',
    saveNewNotificationWarning: 'FormulÃ¡rio precisa ser preenchido corretamente.',
    saveNotificationSuccessSave: 'Recurso salvo com sucesso.',
    saveNotificationSuccessUpdate: 'Recurso atualizado com sucesso.',
    saveNotificationWarning: 'FormulÃ¡rio precisa ser preenchido corretamente.',
  }
};

/**
 * @description
 *
 * O `thf-page-dynamic-edit` Ã© uma pÃ¡gina que pode servir para editar ou criar novos registros,
 * o mesmo tambÃ©m suporta metadados conforme especificado na documentaÃ§Ã£o.
 *
 * @example
 *
 * <example name="thf-page-dynamic-edit-basic" title="Totvs Page Dynamic Edit Basic">
 *  <file name="sample-thf-page-dynamic-edit-basic/sample-thf-page-dynamic-edit-basic.component.html"> </file>
 *  <file name="sample-thf-page-dynamic-edit-basic/sample-thf-page-dynamic-edit-basic.component.ts"> </file>
 * </example>
 *
 * <example name="thf-page-dynamic-edit-user" title="Totvs Page Dynamic Edit - User">
 *  <file name="sample-thf-page-dynamic-edit-user/sample-thf-page-dynamic-edit-user.component.html"> </file>
 *  <file name="sample-thf-page-dynamic-edit-user/sample-thf-page-dynamic-edit-user.component.ts"> </file>
 * </example>
 *
 * <example name="thf-page-dynamic-edit-master-detail" title="Totvs Page Dynamic Edit - Master Detail">
 *  <file name="sample-thf-page-dynamic-edit-master-detail/sample-thf-page-dynamic-edit-master-detail.component.html"> </file>
 *  <file name="sample-thf-page-dynamic-edit-master-detail/sample-thf-page-dynamic-edit-master-detail.component.ts"> </file>
 * </example>
 */
@Component({
  selector: 'thf-page-dynamic-edit',
  templateUrl: './thf-page-dynamic-edit.component.html',
  providers: [ ThfPageDynamicService ]
})
export class ThfPageDynamicEditComponent implements OnInit {

  private _actions: ThfPageDynamicEditActions = {};
  private _autoRouter: boolean = false;
  private _controlFields: Array<any> = [];
  private _detailFields: Array<any> = [];
  private _duplicates: Array<any> = [];
  private _fields: Array<any> = [];
  private _keys: Array<any> = [];
  private _pageActions: Array<ThfPageAction> = [];

  literals = {
    ...thfPageDynamicEditLiteralsDefault[util.thfLocaleDefault],
    ...thfPageDynamicEditLiteralsDefault[util.browserLanguage()]
  };
  model: any = {};

  // beforeSave: return boolean
  // afterSave
  // beforeRemove: return boolean
  // afterRemove
  // beforeInsert: : return boolean
  readonly detailActions: ThfGridRowActions = { };

  /**
   * @optional
   *
   * @description
   *
   * AÃ§Ãµes da pÃ¡gina.
   */
  @Input('t-actions') set actions(value: ThfPageDynamicEditActions) {
    this._actions = this.isObject(value) ? value : {};

    this._pageActions = this.getPageActions(this._actions);
  }

  /**
   * @todo Validar rotas na mÃ£o pois se existir uma rota '**' o catch do navigation nÃ£o funciona.
   *
   * @optional
   *
   * @description
   *
   * Cria automaticamente as rotas de ediÃ§Ã£o (novo/duplicate) e detalhes caso as aÃ§Ãµes
   * estejam definidas nas aÃ§Ãµes.
   *
   * > Para o correto funcionamento nÃ£o pode haver nenhum rota coringa (`**`) especificada.
   *
   * @default false
   */
  @Input('t-auto-router') set autoRouter(value: boolean) {
    this._autoRouter = util.convertToBoolean(value);
  }

  get autoRouter(): boolean {
    return this._autoRouter;
  }

  /** Objeto com propriedades do breadcrumb. */
  @Input('t-breadcrumb') breadcrumb?: ThfBreadcrumb = { items: [] };

  /** Lista dos campos usados na tabela e busca avanÃ§ada. */
  @Input('t-fields') set fields(value: Array<ThfPageDynamicEditField>) {
    this._fields = Array.isArray(value) ? [...value] : [];

    this._keys = this.getKeysByFields(this._fields);
    this._duplicates = this.getDuplicatesByFields(this._fields);

    this._controlFields = this.getControlFields(this._fields);
    this._detailFields = this.getDetailFields(this._fields);
  }

  get fields(): Array<ThfPageDynamicEditField> {
    return this._fields;
  }

  /**
   * @description
   *
   * Endpoint usado pelo template para requisiÃ§Ã£o do recurso que serÃ£o exibido para ediÃ§Ã£o.
   *
   * Para as aÃ§Ãµes de `save` e `saveNew`, serÃ¡ feito uma requisiÃ§Ã£o de criaÃ§Ã£o nesse mesmo endpoint passando os valores
   * preenchidos pelo usuÃ¡rio via payload.
   *
   * > `POST {end-point}`
   *
   * ```
   *  <thf-page-dynamic-edit
   *    [t-actions]="{ save: '/', saveNew: 'new' }"
   *    [t-fields]="[ { property: 'name' }, { property: 'city' } ]"
   *    t-service="/api/thf-samples/v1/people"
   *    ...>
   *  </thf-page-dynamic-edit>
   * ```
   *
   * ResquisiÃ§Ã£o disparada, onde a propriedade `name` e `city` foram preenchidas:
   *
   * ```
   *  POST /api/thf-samples/v1/people HTTP/1.1
   *  Host: localhost:4000
   *  Connection: keep-alive
   *  Accept: application/json, text/plain
   *  ...
   * ```
   *
   * Request payload:
   *
   * ```
   * { "name": "Fulano", "city": "Smallville" }
   * ```
   * > Caso esteja usando metadados com o template, serÃ¡ disparado uma requisiÃ§Ã£o na inicializaÃ§Ã£o do template para buscar
   * > os metadados da pÃ¡gina passando o tipo do metadado esperado e a versÃ£o cacheada pelo browser.
   * >
   * > `GET {end-point}/metadata?type=create&version={version}`
   *
   * Caso queira que o template carregue um recurso jÃ¡ existente, deve-se ser incluÃ­do um parametro na rota chamado `id`.
   *
   * Exemplo de configuraÃ§Ã£o de rota:
   *
   * ```
   *  RouterModule.forRoot([
   *    ...
   *    { path: 'edit/:id', component: PersonEditComponent },
   *    ...
   *  ],
   * ```
   *
   * Baseado nisso, na inicializaÃ§Ã£o do template, serÃ¡ disparado uma requisiÃ§Ã£o para buscar o recurso que serÃ¡ editado.
   *
   * > `GET {end-point}/{id}`
   *
   * Nos mÃ©todos de `save` e `saveNew`, ao invÃ©s de um `POST`, serÃ¡ disparado um `PUT`.
   *
   * ResquisiÃ§Ã£o disparada, onde a propriedade `name` e `city` foram preenchidas / atualizadas, e o `id` da url Ã© 2:
   *
   * ```
   *  PUT /api/thf-samples/v1/people/2 HTTP/1.1
   *  Host: localhost:4000
   *  Connection: keep-alive
   *  Accept: application/json, text/plain
   *  ...
   * ```
   *
   * Request payload:
   *
   * ```
   * { "name": "Fulano", "city": "Metropolis" }
   * ```
   *
   * > Caso esteja usando metadados com o template, serÃ¡ disparado uma requisiÃ§Ã£o na inicializaÃ§Ã£o do template para buscar
   * > os metadados da pÃ¡gina passando o tipo do metadado esperado e a versÃ£o cacheada pelo browser.
   * >
   * > `GET {end-point}/metadata?type=edit&version={version}`
   */
  @Input('t-service-api') serviceApi: string;

  /** TÃ­tulo da pÃ¡gina. */
  @Input('t-title') title: string;

  @ViewChild('dynamicForm', { static: true }) dynamicForm: ThfDynamicFormComponent;
  @ViewChild('gridDetail', { static: true }) gridDetail: ThfGridComponent;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private thfNotification: ThfNotificationService,
    private thfDialogService: ThfDialogService,
    private thfPageDynamicService: ThfPageDynamicService) {
  }

  ngOnInit(): void {
    const paramId = this.activatedRoute.snapshot.params['id'];
    const duplicate = this.activatedRoute.snapshot.queryParams['duplicate'];

    if (this.activatedRoute.snapshot.data.serviceApi) {
      this.serviceApi = this.activatedRoute.snapshot.data.serviceApi;

      this.thfPageDynamicService.configServiceApi({ endpoint: this.serviceApi });

      this.loadMetadata(paramId, duplicate);
    } else {
      this.thfPageDynamicService.configServiceApi({ endpoint: this.serviceApi });

      this.loadData(paramId, duplicate);
    }
  }

  get duplicates() {
    return [...this._duplicates];
  }

  get keys() {
    return [...this._keys];
  }

  get pageActions() {
    return [...this._pageActions];
  }

  get controlFields() {
    return this._controlFields;
  }

  get detailFields() {
    return this._detailFields;
  }

  private cancel(path) {
    if (this.dynamicForm && this.dynamicForm.form.dirty) {
      this.thfDialogService.confirm({
        message: this.literals.cancelConfirmMessage,
        title: this.literals.pageActionCancel,
        confirm: this.goBack.bind(this, path)
      });
    } else {
      this.goBack(path);
    }
  }

  private formatUniqueKey(item) {
    const keys = util.mapObjectByProperties(item, this.keys);

    return util.valuesFromObject(keys).join('|');
  }

  private goBack(path) {
    if (path) {
      this.router.navigate([path]);
    } else {
      window.history.back();
    }
  }

  private loadData(id, duplicate?) {
    if (!id) {
      try {
        this.model = JSON.parse(duplicate) || {};
      } catch {
        this.model = {};
      }

      return;
    }

    this.thfPageDynamicService.getResource(id).toPromise().then(response => {
      this.model = response;
    }).catch(() => {
      this.model = undefined;
      this.actions = undefined;
      this._pageActions = [];
    });
  }

  private loadMetadata(paramId: string | number, duplicate: string) {
    const typeMetadata = paramId ? 'edit' : 'create';

    this.thfPageDynamicService.getMetadata(typeMetadata).toPromise().then(response => {
      this.autoRouter = response.autoRouter;
      this.actions = response.actions || {};
      this.breadcrumb = response.breadcrumb || { items : [] };
      this.fields = response.fields || [];
      this.title = response.title;

      this.loadData(paramId, duplicate);
    });
  }

  private navigateTo(path: string) {
    if (path) {
      const url = this.resolveUrl(this.model, path);

      this.router.navigate([url]);
    } else {
      window.history.back();
    }
  }

  private detailActionNew() {
    this.gridDetail.insertRow();
  }

  private resolveUrl(item: any, path: string) {
    const uniqueKey = this.formatUniqueKey(item);

    return path.replace(/:id/g, uniqueKey);
  }

  private save(path) {
    if (this.dynamicForm.form.invalid) {
      this.thfNotification.warning(this.literals.saveNotificationWarning);
      return;
    }

    const paramId = this.activatedRoute.snapshot.params['id'];

    const saveOperation: Observable<any> = paramId
      ? this.thfPageDynamicService.updateResource(paramId, this.model)
      : this.thfPageDynamicService.createResource(this.model);

    const msgSucess = paramId ? this.literals.saveNotificationSuccessUpdate : this.literals.saveNotificationSuccessSave;

    saveOperation.toPromise().then(() => {
      this.thfNotification.success(msgSucess);

      this.navigateTo(path);
    });
  }

  private saveNew(path) {
    if (this.dynamicForm.form.invalid) {
      this.thfNotification.warning(this.literals.saveNewNotificationWarning);
      return;
    }

    const paramId = this.activatedRoute.snapshot.params['id'];

    if (paramId) {
      this.thfPageDynamicService.updateResource(paramId, this.model)
        .toPromise().then(() => {
          this.thfNotification.success(this.literals.saveNewNotificationSuccessUpdate);

          this.navigateTo(path);
        });
    } else {
      this.thfPageDynamicService.createResource(this.model)
        .toPromise().then(() => {
          this.thfNotification.success(this.literals.saveNewNotificationSuccessSave);

          this.model = {};
          this.dynamicForm.form.reset();
        });
    }
  }

  private getKeysByFields(fields: Array<any> = []) {
    return fields.filter(field => field.key === true).map(field => field.property);
  }

  private getControlFields(fields: Array<any> = []) {
    return fields.filter(field => field.type !== 'detail');
  }

  private getDetailFields(fields: Array<any> = []) {
    return fields.filter(field => field.type === 'detail');
  }

  private getDuplicatesByFields(fields: Array<any> = []) {
    return fields.filter(field => field.duplicate === true).map(field => field.property);
  }

  private getPageActions(actions: ThfPageDynamicEditActions = {}): Array<ThfPageAction> {
    const pageActions = [{ label: this.literals.pageActionSave, action: this.save.bind(this, actions.save) }];

    if (actions.saveNew) {
      pageActions.push({ label: this.literals.pageActionSaveNew, action: this.saveNew.bind(this, actions.saveNew) });
    }

    if (actions.cancel === undefined || actions.cancel) {
      pageActions.push({ label: this.literals.pageActionCancel, action: this.cancel.bind(this, actions.cancel) });
    }

    return pageActions;
  }

  private isObject(value: any): boolean {
    return !!value && typeof value === 'object' && !Array.isArray(value);
  }

}
